import { render, staticRenderFns } from "./OAuthAuthorize.vue?vue&type=template&id=1ebf9a0e&scoped=true"
import script from "./OAuthAuthorize.vue?vue&type=script&lang=js"
export * from "./OAuthAuthorize.vue?vue&type=script&lang=js"
import style0 from "./OAuthAuthorize.vue?vue&type=style&index=0&id=1ebf9a0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebf9a0e",
  null
  
)

export default component.exports